import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

const VIDEO_URL = "https://res.cloudinary.com/tdapd0hq/video/upload/v1790009144/NucleusOS_v1.mov";

const NucleusIntroModal = ({ isDark, onClose }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return createPortal(
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-6"
      onClick={onClose}
      data-testid="nucleus-intro-backdrop"
    >
      <div className={`absolute inset-0 ${isDark ? "bg-black/85" : "bg-black/70"} backdrop-blur-sm`} />
      <div
        className="relative w-full max-w-5xl"
        style={{ aspectRatio: "16/9" }}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          data-testid="nucleus-intro-close"
          className="absolute -top-10 right-0 w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
        <video
          src={VIDEO_URL}
          autoPlay
          controls
          playsInline
          className="w-full h-full rounded-xl bg-black"
          data-testid="nucleus-intro-video"
        >
          Your browser does not support HTML5 video.
        </video>
      </div>
    </div>,
    document.body
  );
};

export default NucleusIntroModal;
